import {
  GetOverviewMetricsPeriod,
  GetOverviewMetricsQueryResult,
  useGetOverviewMetricsQuery,
  useGetOverviewMetricsWithoutDetailedDataQuery,
} from "@covertree/agent-portal-graphql";

export function useGetOverviewMetrics(
  period: GetOverviewMetricsPeriod,
  canSeeOverviewMetricsDetailedData: boolean
) {
  const { data, error, loading } = canSeeOverviewMetricsDetailedData
    ? useGetOverviewMetricsQuery({
        variables: { period },
        fetchPolicy: "network-only",
        nextFetchPolicy: "network-only",
      })
    : useGetOverviewMetricsWithoutDetailedDataQuery({
        variables: { period },
        fetchPolicy: "network-only",
        nextFetchPolicy: "network-only",
      });

  return {
    metrics:
      (data?.getOverviewMetrics
        ?.metrics as GetOverviewMetricsQueryResult["data"]["getOverviewMetrics"]["metrics"]) ||
      undefined,
    period,
    error,
    loading,
  };
}
